<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="search-container">
          <el-input
            v-model="listQuery.keyword"
            class="search-input"
            placeholder="Name or display name"
            prefix-icon="el-icon-search"
            size="mini"
            clearable
          />
          <el-input
            v-model="filter.store_id"
            class="search-input"
            placeholder="Store ID"
            prefix-icon="el-icon-search"
            size="mini"
            clearable
          />
          <el-input
            v-model="filter.advertiser_id"
            class="search-input"
            placeholder="Advertiser ID"
            prefix-icon="el-icon-search"
            size="mini"
            clearable
          />
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            circle
            @click="applyKeywordSearch"
          />
        </div>
        <div class="button-container">
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="handleCreate"
          >
            {{ $t('button.create') }}
          </el-button>
        </div>
      </div>
    </template>
    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="ID"
        width="50"
      />
      <el-table-column
        prop="name"
        label="Name"
        min-width="150"
      />
      <el-table-column
        prop="displayname"
        label="Display Name"
        min-width="150"
      />
      <el-table-column
        prop="gx_affiliate"
        label="Goxip Affiliate"
        min-width="100"
      />
      <el-table-column
        prop="gx_commission"
        label="Goxip Comm %"
        min-width="100"
      />
      <el-table-column
        prop="status"
        label="Goxip Status"
        align="center"
        width="95"
      >
        <template slot-scope="{ row }">
          <div style="display:flex;justify-content:center;">
            <el-tag
              v-if="row.status"
              type="success"
            >
              Online
            </el-tag>
            <el-tag
              v-else
              type="danger"
            >
              Offline
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="rs_affiliate"
        label="RS Affiliate"
        min-width="100"
      />
      <el-table-column
        prop="rs_commission"
        label="RS Comm %"
        min-width="100"
      />
      <el-table-column
        prop="rs_status"
        label="RS Status"
        align="center"
        width="95"
      >
        <template slot-scope="{ row }">
          <div style="display:flex;justify-content:center;">
            <el-tag
              v-if="row.rs_status"
              type="success"
            >
              Online
            </el-tag>
            <el-tag
              v-else
              type="danger"
            >
              Offline
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Action"
        align="center"
        width="100"
      >
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(row)"
          />
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-document"
            circle
            @click="handleListSubscriptionBill(row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :disabled="isLoading"
        :current-page="listQuery.page"
        :page-sizes="listQuery.sizes"
        :page-size="listQuery.size"
        :total="listQuery.total"
        background
        layout="total, sizes, pager, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </div>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../mixins/useTablePaging'
import { getStoresWithPaging } from '../../api/stores'

export default {
  name: 'StoreList',
  mixins: [useTablePaging],
  data() {
    return {
      filter: {
        store_id: '',
        advertiser_id: '',
      },
    }
  },
  computed: {
    canApplyKeywordSearch() {
      return !!this.listQuery.keyword
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await getStoresWithPaging({
          page: this.listQuery.page,
          size: this.listQuery.size,
          keyword: this.listQuery.keyword,
          storeId: this.filter.store_id,
          advertiserId: this.filter.advertiser_id,
        })

        const { data, pagination } = response
        const { stores } = data

        if (Array.isArray(stores)) {
          for (let i = 0; i < stores.length; i++) {
            let store = stores[i]

            if (store.gx_feed_affiliate === store.gx_deeplink_affiliate) {
              store.gx_affiliate = store.gx_feed_affiliate
            } else {
              store.gx_affiliate = `${store.gx_feed_affiliate} / ${store.gx_deeplink_affiliate}`
            }

            if (store.gx_min_commission_percentage === store.gx_max_commission_percentage) {
              store.gx_commission = `${store.gx_min_commission_percentage} %`
            } else {
              store.gx_commission = `${store.gx_min_commission_percentage} - ${store.gx_max_commission_percentage} %`
            }

            if (store.rs_feed_affiliate === store.rs_deeplink_affiliate) {
              store.rs_affiliate = store.rs_feed_affiliate
            } else {
              store.rs_affiliate = `${store.rs_feed_affiliate} / ${store.rs_deeplink_affiliate}`
            }

            if (store.rs_min_commission_percentage === store.rs_max_commission_percentage) {
              store.rs_commission = `${store.rs_min_commission_percentage} %`
            } else {
              store.rs_commission = `${store.rs_min_commission_percentage} - ${store.rs_max_commission_percentage} %`
            }
          }

          this.list = stores
        }

        this.listQuery.total = +pagination.total_items
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    applyKeywordSearch() {
      this.getList()
    },
    handleCreate() {
      this.$router.push({ path: '/store/create' })
    },
    handleUpdate(row) {
      this.$router.push({ path: `/store/edit/${row.id}` })
    },
    handleListSubscriptionBill(row) {
      this.$router.push({ path: `/store/subscription-billing/${row.id}` })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
.search-container {
  display:flex;
  .search-input {
    width: 200px;
    margin-right: 10px;
  }
  button {
    margin: 0 5px;
  }
}
.pagination-container {
  padding: 10px 0;
}
</style>

